import { Domain as Base } from "../"


export namespace Domain {
    export interface IProduct extends Base.IBaseDomain {
        /**
         * 產品類型
         */
        type?: ProductType
        deviceserialno: string
        /**
         * 產品序號
         */
        serialno: string
        /**
         * 建立日期
         */
        createdate?: Date
        /**
         * 產品說明
         */
        description: string
        /**
         * 建立
         * User 用戶 Machine設備本身 SiteAdmin 生產單位
         */
        createby: CreatebyType
        /**
         * 資料上傳與控制密碼
         */
        hash: string
        /**
         * 上次活動日期
         */
        lastuploaddate?: Date
        /**
         * 設備名稱(由本地或遠端更新)
         */
        name: string
        /**
         * 此設備可否被控制，該權限為最高權限
         */
        enablecontrol: boolean
        /**
         * 此設備可否被啟用
         */
        enable: boolean
    }
    export enum CreatebyType {
        None = 0x0,
        User = 0xB0,
        Machine = 0x100,
        SiteAdmin = 0x120,
    }

    export enum ProductType {
        SmartPanel = "SCP",
        SmartCB = "SCB",
        SmartPlug = "SPG",
        EnergyStrogeSystem = "ESS",
        WSN = "WSN",
        IAQ = "IAQ"
    }
}




// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/lib/Domain/Product/index.ts